import { XIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface SplitViewHeaderProps {
  title: string
  subtitle?: string
  icon?: ReactNode
  onClose: () => void
  onTitleClick?: () => void
  isCloseButtonHidden?: boolean
  className?: string
}

export const SplitViewHeader: React.FC<SplitViewHeaderProps> = ({
  title,
  subtitle,
  icon,
  onClose,
  onTitleClick,
  isCloseButtonHidden = false,
  className,
}): ReactNode => {
  const TitleWrapper = onTitleClick ? 'button' : 'div'

  return (
    <div
      className={cn(
        'split-view-header flex items-center justify-between border-b bg-background px-4 py-3',
        className
      )}
    >
      <TitleWrapper
        type={onTitleClick ? 'button' : undefined}
        onClick={onTitleClick}
        className={cn(
          'flex min-w-0 items-center gap-3',
          onTitleClick && 'text-left hover:opacity-70 transition-opacity'
        )}
      >
        {icon && <div className="split-view-header-icon flex-shrink-0">{icon}</div>}
        <div className="min-w-0">
          <h2 className="split-view-title truncate text-sm font-semibold">{title}</h2>
          {subtitle && (
            <p className="split-view-subtitle truncate text-xs text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </TitleWrapper>
      {!isCloseButtonHidden && (
        <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="split-view-close-button flex-shrink-0"
          aria-label="Close split view"
        >
          <XIcon className="size-4" />
        </Button>
      )}
    </div>
  )
}
